import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { business, ESTIMATE_PATH } from "@/data/site";
import { track } from "@/lib/analytics";

// Primary CTA = Call Now. Secondary CTA = Request Estimate.
export const CallNowButton = ({ className = "", size = "md", label = "Call Now", testid = "call-now-btn" }) => {
  const sizes = { sm: "px-4 py-2 text-sm", md: "px-6 py-3 text-base", lg: "px-8 py-4 text-lg" };
  return (
    <a
      href={business.phoneHref}
      onClick={() => track("call_now_click", { location: testid })}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 bg-[#059669] text-white font-bold uppercase tracking-wide border-2 border-[#059669] hover:bg-[#047857] hover:border-[#047857] hover:-translate-y-0.5 transition-transform duration-200 ${sizes[size]} ${className}`}
    >
      <Phone className="w-5 h-5" strokeWidth={2.5} />
      {label}
    </a>
  );
};

export const EstimateButton = ({ className = "", size = "md", label = "Request a Free Estimate", testid = "estimate-btn" }) => {
  const sizes = { sm: "px-4 py-2 text-sm", md: "px-6 py-3 text-base", lg: "px-8 py-4 text-lg" };
  return (
    <Link
      to={ESTIMATE_PATH}
      onClick={() => track("free_estimate_click", { location: testid })}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 bg-[#0F2E4C] text-white font-bold uppercase tracking-wide border-2 border-[#0F2E4C] hover:bg-[#1A4A6B] hover:-translate-y-0.5 transition-transform duration-200 ${sizes[size]} ${className}`}
    >
      <CalendarCheck className="w-5 h-5" strokeWidth={2.5} />
      {label}
    </Link>
  );
};

export const OutlineButton = ({ to, children, className = "", testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`inline-flex items-center justify-center gap-2 bg-transparent text-[#0F2E4C] font-bold uppercase tracking-wide border-2 border-[#0F2E4C] px-6 py-3 hover:bg-[#0F2E4C] hover:text-white transition-colors duration-200 ${className}`}
  >
    {children}
  </Link>
);
